import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "src/app/Models/APIEndPoints/APIName";

@Injectable({
  providedIn: "root",
})
export class ContactService {
  constructor(private dataService: DataService) {}

  submit(userData: IContact): Observable<any> {
    return this.dataService.post(APIName.client.contact, userData);
  }
}
// create the user interface
interface IContact {
  name: string;
  email: string;
  phone: string;
}
